import React from "react";
import AllahNameCard from "@components/items/display/AllahNameCard";
import { getPublicMediaUrl } from "@modules/api/util/mediaHelper";
import { RamadanBackground } from "@pages/content/ramadan/RamadanPage";
import { X } from "lucide-react";
import { ItemParams } from "./TitledHorizontalList";
import { Server } from "@wajeez/wajeez.microservices";
import { OnItemPress } from "@modules/content/hooks/useComponentData";

interface AllahNamesSheetProps {
  seeAllShown: boolean;
  setSeeAllShown: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  items: ItemParams[];
  onItemPress: OnItemPress<ItemParams>;
  contents:
    | (Server.ContentEntityOutput & {
        isLocked: boolean | undefined;
        lockType: Server.LockType | undefined;
      })[];
}
const AllahNamesSheet = ({
  seeAllShown,
  setSeeAllShown,
  title,
  items,
  onItemPress,
  contents,
}: AllahNamesSheetProps) => {
  return (
    <div>
      {seeAllShown && (
        <div
          className={`absolute inset-0 z-10 transition-opacity duration-300 ${
            seeAllShown ? "opacity-100" : "pointer-events-none opacity-0"
          }`}
          onClick={() => setSeeAllShown(false)}
        />
      )}
      <div
        className={`fixed bottom-0 end-0 start-[100px] top-[100px] z-10 h-full w-full transform rounded-t-lg bg-white shadow-lg transition-transform duration-300 ease-in-out dark:bg-black ${
          seeAllShown ? "translate-y-0" : "translate-y-full"
        }`}
      >
        <div
          className="absolute start-4 top-4 h-6 w-6 cursor-pointer"
          onClick={() => setSeeAllShown(false)}
        >
          <X className="text-ramadan-primary dark:text-dark-ramadan-primary" />
        </div>
        <div className="relative -top-10 end-24">
          <RamadanBackground />
        </div>
        <div className="flex w-[90%] flex-col justify-center gap-10 p-5">
          <div className="self-center text-[36px] font-bold text-ramadan-primary dark:text-dark-ramadan-primary">
            {title}
          </div>
          <div className="cus-scrollbar-w-none mx-auto grid h-[80vh] w-full grid-cols-2 gap-y-5 overflow-y-auto pb-[100px] sm:grid-cols-3 md:grid-cols-5 xl:grid-cols-6">
            {items.map((item, i) => (
              <AllahNameCard
                key={item.id}
                image={getPublicMediaUrl(item.image)}
                title={item.title ?? ""}
                writer={item.authors?.toString().replaceAll(",", ", ") ?? ""}
                isLockedContent={
                  contents.find((c) => c.id === item.id)?.isLocked
                }
                onClick={() => {
                  const content = contents.find((c) => c.id === item.id);

                  content &&
                    onItemPress(content, item, { isLocked: content.isLocked });
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllahNamesSheet;
